module.exports = __webpack_public_path__ + "img/checkout_item.5dd287c6.svg";